import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from '../../utils/customBaseQuery';


export const userApi = createApi({
	reducerPath: 'userApi',
	baseQuery: customBaseQuery,
	refetchOnFocus: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		// GET-получить всех пользователей
		allUsers: builder.query({
			query: () => ({
				url: '/all',
				method: 'GET',
				prefix: "user"
			}),
		}),

		// GET-получить пользователя по tgId
		getUserById: builder.query({
			query: (tgId) => ({
				url: `/${tgId}`,
				method: 'GET',
				prefix: "user"
			}),
		}),

		// POST-Создать пользователя
		authUser: builder.mutation({
			query: (tgId) => ({
				url: '/auth',
				method: 'POST',
				body: { tgId },
				prefix: "user"
			}),
		}),

		// POST-добавить device пользователю
		addDeviceUser: builder.mutation({
			query: ({ userId, deviceId }) => ({
				url: '/addDevice',
				method: 'POST',
				body: { userId, deviceId },
				prefix: "user"
			}),
		}),

		// POST-удалить device пользователю
		removeDeviceUser: builder.mutation({
			query: ({ userId, deviceId }) => ({
				url: '/removeDevice',
				method: 'POST',
				body: { userId, deviceId },
				prefix: "user"
			}),
		}),

		// PUT-обновить данные пользователя
		updateUser: builder.mutation({
			query: (data) => ({
				url: '/update',
				method: 'PUT',
				body: data,
				prefix: "user"
			}),
		}),
	}),
});

export const {
	useAuthUserMutation,
	useAllUsersQuery,
	useAddDeviceUserMutation,
	useRemoveDeviceUserMutation,
	useGetUserByIdQuery,
	useUpdateUserMutation,
} = userApi;
